import React, { Fragment, useState } from 'react'
import Box from '@material-ui/core/Box'

import SharedForm from '../../../shared/SharedForm'
import Input from '../../../shared/inputs/Input'
import { confirmWithOtpClick, submitSaveRetirementScenarioForm } from '../saveRetirementScenarioHelpers'

export const OptionalOtpScreen = (props) => {
  const [savingInProgress, setSavingInprogress] = useState(false)

  return (
    <div className='save-scenario-dialog__risk-change'>
      <h1>Risk profile change detected</h1>
      <div className='row'>
        <div className='small-12 columns'>
          <OptionalOtpParagraph />
          <OptionalOtpForm
            savingInProgress={savingInProgress}
            setSavingInprogress={setSavingInprogress}
            {...props}
          />
        </div>
      </div>
    </div>
  )
}

const OptionalOtpParagraph = () =>
  <Fragment>
    <p>
      We have detected a change in risk profile. Changing the risk profile will greatly impact the outcome of the financial projections.
    </p>
    <p>
      <b>
        We strongly suggest that you confirm this change with your client by sending a One Time Pin to their phone.
      </b>
    </p>
  </Fragment>

const OptionalOtpForm = (props) =>
  <SharedForm actionUrl={props.url} methodType='POST' authenticityToken={props.authenticityToken}>
    <input type='hidden' name='_method' value={props.method} />
    <Input
      hidden name='retirement_scenario[name]' id='retirement_scenario_name_input'
      label='give your plan a name' isHalf={false}
      value={props.scenarioName} onChange={(value) => props.setScenarioName(value)}
    />

    {props.isWealthManager && props.sendImplementationNoticeToClient &&
      <div className='row'>
        <div style={{ float: 'right', marginBottom: '2rem', marginTop: '-1rem', marginRight: '1rem' }}>
          <input
            type='hidden'
            id='client_send_implement_notification_input'
            name='send_implement_notification'
            value={props.sendImplementationNoticeToClient}
            label='notify client of changes when implementing'
            onChange={(value) => props.setSendImplementationNoticeToClient(value)}
          />
        </div>
      </div>}

    {props.isWealthManager && props.advisorDeclarationAcceptance &&
      <div className='row'>
        <div style={{ float: 'right', marginBottom: '2rem', marginTop: '-1rem', marginRight: '1rem' }}>
          <input
            type='hidden'
            id='advisor_delcaration_acceptance_input'
            name='advisor_declaration_acceptance'
            value={props.advisorDeclarationAcceptance}
          />
        </div>
      </div>}

    <div className='row'>
      <Box
        className='flex gap-4'
      >
        <ImplementWithoutConfirmationButton
          {...props}
          onClick={() => submitSaveRetirementScenarioForm(props, { implement: true, status: 'approved' })}
          savingInProgress={props.savingInProgress}
        />
        <ConfirmWithOTPButton
          {...props}
          onClick={() => confirmWithOtpClick(props)}
          savingInProgress={props.savingInProgress}
        />
      </Box>
    </div>
  </SharedForm>

const ImplementWithoutConfirmationButton = (props) =>
  <input
    name='implement'
    value={`${props.savingInProgress ? 'Saving...' : 'Skip confirmation'}`}
    type='button'
    className={`full-width button ${props.savingInProgress ? 'disabled' : 'button--secondary'}`}
    disabled={props.savingInProgress || props.disabled}
    onClick={props.onClick}
    data-tracking='true'
    data-event='Implement Without Confirmation'
    data-event-details={`{"client_id": ${props.clientId}, "retirement_scenario_id": ${props.retirementScenarioId}}`}
  />

const ConfirmWithOTPButton = (props) =>
  <input
    name='confirmWithOTP'
    value='Confirm with an OTP'
    type='button'
    className={`full-width button ${props.savingInProgress ? 'disabled' : ''}`}
    disabled={props.savingInProgress || props.disabled}
    onClick={props.onClick}
    data-tracking='true'
    data-event='Confirm Risk change with OTP'
    data-event-details={`{"client_id": ${props.clientId}, "retirement_scenario_id": ${props.retirementScenarioId}}`}
  />
